import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {translate, TranslocoService} from '@ngneat/transloco';
import {CommandsSchema, IndustrialGatewayComponent} from '@iotsens/commands';
import {CommandExec} from '@iotsens/commands/src/lib/_shared/domain/command-exec.model';
import {DeviceMeasurement} from '../../../../../model/device-measurement';
import {DevicesService} from '../../../../../services/devices.service';
import {Device} from '../../../../../model/device';

@Component({
  selector: 'app-industrial-gateway-commands',
  templateUrl: './industrial-gateway-commands.component.html',
  styleUrls: ['./industrial-gateway-commands.component.scss']
})
export class IndustrialGatewayCommandsComponent implements OnInit {

  @Input() schema: CommandsSchema;
  @Input() device: Device;

  @Output() executeCommand: EventEmitter<CommandExec>;

  @ViewChild('industrialGateway')
  industrialGateway: IndustrialGatewayComponent;


  public configuration: any;
  public deviceMeasurements: DeviceMeasurement[];
  public deviceGateway: string;

  constructor(private i18n: TranslocoService, private devicesService: DevicesService) {
    this.executeCommand = new EventEmitter<CommandExec>();
  }

  ngOnInit(): void {
    this.setConfiguration();
    this.loadData();
  }

  private loadData(): void {
    this.devicesService.getDeviceIntegrationModules(this.device.uuid).subscribe(response => {
        const additionalInfo = JSON.parse(response.integrationModules.filter(im => im.encoder.name === this.schema.name)[0].additionalInfo);
        const subString = additionalInfo.entryPoint.split('.devices.')[0];
        const lastIndex = subString.lastIndexOf('.');
        this.deviceGateway = subString.substr(lastIndex + 1);
        this.industrialGateway.setDeviceGateway(this.deviceGateway);
      }
    );

    this.devicesService.getDeviceMeasurementsOfDeviceFilteredByMeasurementTypeSensor(this.device.uuid, defaultMeasurementTypeSensor)
      .then((response: DeviceMeasurement[]): void => {
        this.deviceMeasurements = response;
      });
  }

  private setConfiguration(): void {
    this.i18n.selectTranslation().subscribe(() => {
      this.configuration = {
        classes: 'col-12',
        inline: true,
        buttonClasses: 'w-10rem',
        literals: {
          command: 'Industrial Gateway',
          params: {
            sensorName: {
              name: translate('device.params.sensorName')
            },
            sensorValue: {
              name: translate('device.params.sensorValue')
            }
          },
          button: translate('device.buttons.sendCommand')
        }
      };
    });
  }

}

export const defaultMeasurementTypeSensor = 'Comando';
